export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/makers_experience_perseus/apps/Illustration-value-3.f4370f0.svg";